import {DefaultSchema} from '@/schema/DefaultSchema'
import {FieldComponent, FieldSet} from '@simpli/meta-schema'
import * as Component from '@simpli/vue-input'
import {DappConnection} from '@/model/resource/DappConnection'

export class InputDappConnectionSchema extends DefaultSchema {
  readonly name = 'InputDappConnection'

  readonly fieldSet: FieldSet<DappConnection> = {
    title: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 70,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
